import React from "react";
import { DateTime } from "luxon";
import { GanttSort } from "@planzone/dto";
import {
  useRetrieveGantt,
  useRetrieveCurrentPlanzone,
  useRetrieveGanttCalendarRange,
  useRetrievePreferences,
} from "@planzone/view-models";
import { Props } from "./types";
import { useMessage } from "@components/useMessage";
import { Workloads } from "@scenes/workloads";

function WorkloadsPage(_: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { preferences } = useRetrievePreferences();
  const savedSort: GanttSort = (preferences[
    `${planzone.uuid}:workloadsSort` as keyof typeof preferences
  ] || "ascendingRank") as GanttSort;
  const [sort, setSort] = React.useState<GanttSort>(savedSort);
  const {
    isRequestPending,
    gantt,
    currentPage,
    canRetrieveNextElements,
    retrieveGantt,
  } = useRetrieveGantt(10, sort);
  const {
    isRequestPending: isCalendarRequestPending,
    isRequestSuccess: isCalendarRequestSuccess,
    isRequestFailure: isCalendarRequestFailure,
    range,
    retrieveGanttCalendarRange,
  } = useRetrieveGanttCalendarRange();

  React.useEffect(() => {
    !isCalendarRequestPending &&
      !isCalendarRequestSuccess &&
      !isCalendarRequestFailure &&
      retrieveGanttCalendarRange({});
  }, []);

  useMessage(
    ({ type }) =>
      ["Task", "List", "Milestone", "Event"].find(
        (elementType) =>
          type === `create${elementType}Succeeded` ||
          type === `edit${elementType}Succeeded`,
      ) && retrieveGanttCalendarRange({}),
  );

  React.useEffect(() => {
    !isCalendarRequestPending &&
      !isCalendarRequestSuccess &&
      !isCalendarRequestFailure &&
      retrieveGanttCalendarRange({});
  }, []);

  return (
    <>
      <Workloads
        projects={gantt.projects}
        range={
          !!range[0] && !!range[1]
            ? { minDate: range[0], maxDate: range[1] }
            : (() => {
                const now = DateTime.now().toUTC().toISO() ?? "";
                return { minDate: now, maxDate: now };
              })()
        }
        filter={{ scope: "planzone", elementTypes: ["task", "list"] }}
        sort="ascendingRank"
        namespace={planzone.uuid}
        isFetchingProjects={isRequestPending}
        canRetrieveProjects={!isRequestPending && canRetrieveNextElements}
        retrieveProjects={() =>
          retrieveGantt({ size: 10, page: currentPage, sort })
        }
        selectSort={(nextSort) => sort !== nextSort && setSort(nextSort)}
      />
    </>
  );
}

export { WorkloadsPage };
